/**
* Product page adjustments shared across templates
*
* - Move the first child in `[data-product-blocks]` into `.product-block--header`
*   on all product pages. This needs to be the Okendo Reviews block in the Customizer.
*/
// (function() {
//   'use strict';

//   function moveFirstProductBlockToHeader(root) {
//     var scope = root && root.querySelector ? root : document;
//     var header = scope.querySelector('.product-block--header');
//     var firstBlock = scope.querySelector('[data-product-blocks] > :first-child');
//     if (!header || !firstBlock) return;
//     if (header.classList.contains('header-block-prepended')) return;
//     if (!header.contains(firstBlock)) {
//       header.insertBefore(firstBlock, header.firstChild);
//     }
//     header.classList.add('header-block-prepended');
//   }

//   function initProductHeaderAdjustments() {
//     moveFirstProductBlockToHeader(document);

//     var observer = new MutationObserver(function(mutations) {
//       for (var i = 0; i < mutations.length; i++) {
//         var m = mutations[i];
//         if (m.type === 'childList') {
//           moveFirstProductBlockToHeader(document);
//         }
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initProductHeaderAdjustments);
//   } else {
//     initProductHeaderAdjustments();
//   }
// })();

/**
* Product page adjustments shared across templates
*
* - Move the first child in `[data-product-blocks]` into `.product-block--header`
*   on all product pages. This needs to be the Okendo Reviews block in the Customizer.
*/
// (function() {
//   'use strict';

//   function moveFirstProductBlockToHeader(root) {
//     var scope = root && root.querySelector ? root : document;
//     var header = scope.querySelector('.product-block--header');
//     var firstBlock = scope.querySelector('[data-product-blocks] > :first-child');
//     if (!header || !firstBlock) return;
//     if (header.classList.contains('header-block-prepended')) return;
//     if (!header.contains(firstBlock)) {
//       header.insertBefore(firstBlock, header.firstChild);
//     }
//     header.classList.add('header-block-prepended');
//   }

//   function initProductHeaderAdjustments() {
//     moveFirstProductBlockToHeader(document);

//     var observer = new MutationObserver(function(mutations) {
//       for (var i = 0; i < mutations.length; i++) {
//         var m = mutations[i];
//         if (m.type === 'childList') {
//           moveFirstProductBlockToHeader(document);
//         }
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initProductHeaderAdjustments);
//   } else {
//     initProductHeaderAdjustments();
//   }
// })();

/**
* Product page and Quick View modal adjustments
*
* Ensure the Okendo rating summary `div[data-oke-reviews-product-listing-rating]`
* appears above the feature block `.product-single__feature` inside the
* `.product-block--header`, both on full product pages and inside quick view modals.
*
* We intentionally avoid generic reordering (like moving the first product block),
* and instead precisely move only the Okendo rating node when present.
*/
// (function() {
// 'use strict';

/**
 * Move the Okendo rating node to the correct position within the header
 * of each `.product-single__meta` container found in the provided scope.
 * 
 * Order: Okendo rating → Feature (if exists) → Title
 *
 * - Works for both full product pages and quick view modals
 * - Safe to run multiple times; it marks nodes after moving to avoid repeats
 * - Handles dynamically loaded content by checking all possible locations
 */
// function moveOkendoRatingToCorrectPosition(root) {
//   var scope = root && root.querySelectorAll ? root : document;
//   var metas = scope.querySelectorAll('.product-single__meta');
//   if (!metas || !metas.length) return;

//   metas.forEach(function(meta) {
//     var header = meta.querySelector('.product-block--header');
//     if (!header) return;

//     // Look for feature and title elements
//     var feature = header.querySelector('.product-single__feature, .product-single_feature');
//     var title = header.querySelector('h1.h2, .product-single__title, .product-single_title');
    
//     // Need at least a title to anchor to
//     if (!title) return;

//     // Find the Okendo rating anywhere within this product meta context
//     var rating = meta.querySelector('div[data-oke-reviews-product-listing-rating]');
//     if (!rating) return;

//     // Avoid repeated moves
//     if (rating.classList && rating.classList.contains('okendo-rating-moved')) return;

//     // Determine the target position
//     var targetElement = feature || title;
    
//     // If rating is already immediately before target, mark and skip
//     if (targetElement.previousElementSibling === rating) {
//       rating.classList.add('okendo-rating-moved');
//       return;
//     }

//     // Move the rating node into the header, just above the target element
//     if (targetElement.parentNode) {
//       targetElement.parentNode.insertBefore(rating, targetElement);
//       rating.classList.add('okendo-rating-moved');
//     }
//   });
// }

/**
 * More aggressive approach: Look for Okendo ratings that might be deeply nested
 * and move them to the correct position. This handles cases where the rating
 * is loaded dynamically and might be in unexpected locations.
 */
// function moveOkendoRatingAggressive(root) {
//   var scope = root && root.querySelectorAll ? root : document;
//   var ratings = scope.querySelectorAll('div[data-oke-reviews-product-listing-rating]');
//   if (!ratings || !ratings.length) return;

//   ratings.forEach(function(rating) {
//     // Skip if already moved
//     if (rating.classList && rating.classList.contains('okendo-rating-moved')) return;

//     // Find the closest product-single__meta container
//     var meta = rating.closest('.product-single__meta');
//     if (!meta) return;

//     var header = meta.querySelector('.product-block--header');
//     if (!header) return;

//     // Look for feature and title elements
//     var feature = header.querySelector('.product-single__feature, .product-single_feature');
//     var title = header.querySelector('h1.h2, .product-single__title, .product-single_title');
    
//     // If rating is already in the header, mark and skip
//     if (header.contains(rating)) {
//       rating.classList.add('okendo-rating-moved');
//       return;
//     }

//     // Need at least a title to anchor to
//     if (!title) return;

//     // Determine the target position: feature if it exists, otherwise title
//     var targetElement = feature || title;
    
//     // If rating is already immediately before target, mark and skip
//     if (targetElement.previousElementSibling === rating) {
//       rating.classList.add('okendo-rating-moved');
//       return;
//     }

//     // Move the rating node into the header, just above the target element
//     if (targetElement.parentNode) {
//       targetElement.parentNode.insertBefore(rating, targetElement);
//       rating.classList.add('okendo-rating-moved');
//     }
//   });
// }

// function initProductHeaderAdjustments() {
//   // Run both approaches to catch different scenarios
//   moveOkendoRatingToCorrectPosition(document);
//   moveOkendoRatingAggressive(document);

//   var observer = new MutationObserver(function(mutations) {
//     for (var i = 0; i < mutations.length; i++) {
//       var m = mutations[i];
//       if (m.type === 'childList') {
//         // Check for any added nodes that might contain Okendo ratings
//         var hasRelevantChanges = false;
//         for (var j = 0; j < m.addedNodes.length; j++) {
//           var node = m.addedNodes[j];
//           if (node.nodeType === 1) { // Element node
//             if (node.querySelector && node.querySelector('div[data-oke-reviews-product-listing-rating]')) {
//               hasRelevantChanges = true;
//               break;
//             }
//             if (node.matches && node.matches('div[data-oke-reviews-product-listing-rating]')) {
//               hasRelevantChanges = true;
//               break;
//             }
//           }
//         }
        
//         if (hasRelevantChanges) {
//           moveOkendoRatingToCorrectPosition(document);
//           moveOkendoRatingAggressive(document);
//         }
//       }
//     }
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Also run periodically to catch any missed dynamic content
//   setInterval(function() {
//     moveOkendoRatingAggressive(document);
//   }, 1000);

//   // Debug: Log what we find
//   setTimeout(function() {
//     var ratings = document.querySelectorAll('div[data-oke-reviews-product-listing-rating]');
//     //console.log('Found', ratings.length, 'Okendo ratings');
//     ratings.forEach(function(rating, index) {
//       var meta = rating.closest('.product-single__meta');
//       var header = meta ? meta.querySelector('.product-block--header') : null;
//       //console.log('Rating', index, 'in meta:', !!meta, 'header:', !!header, 'already moved:', rating.classList.contains('okendo-rating-moved'));
//     });
//   }, 3000);
// }

// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', initProductHeaderAdjustments);
// } else {
//   initProductHeaderAdjustments();
// }
// })();



/**
* Okendo Reviews Custom Page Transition Override
* 
* This script prevents the Motion theme's page transition system from interfering
* with Okendo Reviews interactive elements, specifically media strip items.
* 
* The theme normally intercepts all anchor clicks to add a page transition
* effect, but this interferes with Okendo's interactive review media.
* 
* Usage: Include this script after the main theme.js file
*/

(function() {
  'use strict';
  
  /**
   * Ensure Okendo media links are excluded from theme page transitions
   * by adding the `js-no-transition` class. This lets Okendo's own
   * click handlers open the modal instead of the theme intercepting
   * and navigating directly to the image URL.
   */
  function markOkendoMediaLinks(root) {
    /**
     * We target both public and JS hook classes used by Okendo for
     * media strip items. We only add the class if it's missing.
     */
    const selector = 'a.okeReviews-mediaStrip-item, a.js-okeReviews-mediaStrip-item';
    const scope = root && root.querySelectorAll ? root : document;
    const anchors = scope.querySelectorAll(selector);
    anchors.forEach(function(anchor) {
      if (!anchor.classList.contains('js-no-transition')) {
        anchor.classList.add('js-no-transition');
      }
    });
  }
  
  // Initialize when DOM is ready
  function initOkendoCustomization() {
    markOkendoMediaLinks(document);
    interceptOkendoMediaClicks();
  }
  
  /**
   * Intercept clicks on Okendo media anchors in the capture phase and
   * prevent the browser from navigating to the image URL. We do not stop
   * propagation so that Okendo's own handlers can still open the modal.
   */
  function interceptOkendoMediaClicks() {
    const selector = 'a.okeReviews-mediaStrip-item, a.js-okeReviews-mediaStrip-item';
    document.addEventListener('click', function(evt) {
      var target = evt.target;
      if (!target) return;
      var anchor = target.closest && target.closest('a');
      if (!anchor) return;
      if (!anchor.matches(selector)) return;
      // Allow meta/ctrl clicks to open in new tab as normal
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button && evt.button !== 0) return;
      // Critical: prevent default navigation so Okendo modal can take over
      evt.preventDefault();
      // Do NOT stop propagation; Okendo's handlers should still receive the event
    }, true); // capture phase to run before any bubbling handlers
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOkendoCustomization);
  } else {
    initOkendoCustomization();
  }
  
  // Also run when new content is added (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Apply class to any newly added Okendo media links
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && (node.matches('a.okeReviews-mediaStrip-item') || node.matches('a.js-okeReviews-mediaStrip-item'))) {
              markOkendoMediaLinks(node);
            }
            // Also check for Okendo anchors within the added node
            markOkendoMediaLinks(node);
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  })();
  
  
  